import {
  Box,
  createListCollection,
  Input,
  Portal,
  Select,
  SimpleGrid,
} from "@chakra-ui/react";
import { useState } from "react";
import Field from "../field";
import CreateMilestone from "./CreateMilestone";
import { OfferForm } from "../../pages/ProjectSetup/types/OfferObject";

// const paymentOptions = ['Payment at completion', 'Milestone'];

const paymentOptionCollection = createListCollection({
  items: ["Milestone"],
  itemToString: (item) => item,
  itemToValue: (item) => item,
});

const FixedCostForm = ({
  currencySymbol = "$",
  description,
  jobDetail,
  isBasic,
  onDone,
}: {
  currencySymbol?: string,
  description: string;
  jobDetail: any;
  isBasic?: boolean;
  onDone: (data: OfferForm) => void;
}) => {
  const [paymentOption, setPaymentOption] = useState(
    paymentOptionCollection.items[0]
  );
  const [projectDuration, setProjectDuration] = useState(0);
  const [projectBudget, setProjectBudget] = useState(
    jobDetail?.project_budget ?? 0
  );

  return (
    <>
      {/* <Formik
          onSubmit={handleSubmit}
          validationSchema={FixedCostSchema}
          enableReinitialize
          initialValues={initialFixedCostValues}
        >
          {({
            values,
            setFieldTouched,
            isValid,
            setFieldValue,
            errors,
            handleSubmit,
            ...formik
          }) => (
            <Form> */}
      <SimpleGrid columns={[1, null, 2]} gap={5}>
        {/* <InputSelect
                  label={'Payment type'}
                  name={'payment_type'}
                  id={'payment_type'}
                  placeholder={'Select a payment type'}
                  value={jobDetail?.payment_type ?? ''}
                  setFieldValue={setFieldValue}
                  isValid={values?.payment_type && !errors?.payment_type}
                  setFieldTouched={setFieldTouched}
                  handleSubmit={handleSubmit}
                  options={paymentOptions}
                  setOption={handleOption}
                /> */}

        <Field label="Select a payment type">
          <Select.Root
            collection={paymentOptionCollection}
            value={[paymentOption]}
            onValueChange={({ value }) => setPaymentOption(value[0])}
          >
            <Select.HiddenSelect />
            <Select.Control borderWidth={"thin"} rounded="md">
              <Select.Trigger px={2}>
                <Select.ValueText
                  _placeholder={{ color: "fg.muted" }}
                  placeholder="Select an interval"
                />
              </Select.Trigger>
              <Select.IndicatorGroup>
                <Select.Indicator />
              </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
              <Select.Positioner>
                <Select.Content color="fg">
                  {paymentOptionCollection.items.map((option) => (
                    <Select.Item key={option} item={option}>
                      <Select.ItemText>
                        {paymentOptionCollection.stringifyItem(option)}
                      </Select.ItemText>
                      <Select.ItemIndicator />
                    </Select.Item>
                  ))}
                </Select.Content>
              </Select.Positioner>
            </Portal>
          </Select.Root>
        </Field>

        <Field
          label="Project duration (days)"
          errorText={projectDuration < 1 ? "Enter valid duration" : undefined}
        >
          <Input
            // className="border border-input rounded-md px-[13px] py-2 outline-0 text-muted-foreground"
            px={2}
            borderWidth={"thin"}
            type={"number"}
            min={1}
            placeholder="...in days"
            value={isNaN(projectDuration) ? "" : projectDuration}
            onChange={(e) =>
              setProjectDuration(Number.parseInt(e.target.value) || 0)
            }
          />
        </Field>

        <Field
          label="Project Budget"
          errorText={projectBudget < 1 ? "Enter project budget" : undefined}
        >
          <Input
            // className="border border-input rounded-md px-[13px] py-2 outline-0 text-muted-foreground"
            px={2}
            borderWidth={"thin"}
            type="number"
            min={1}
            placeholder="Project budget eg 1,000"
            value={isNaN(Number(projectBudget)) ? "" : projectBudget}
            onChange={(e) => setProjectBudget(Number(e.target.value) || 0)}
          />
        </Field>
      </SimpleGrid>
      {/* </Form>
          )}
        </Formik> */}

      <Box mt={2}>
        {/* {option === 'Payment at completion'&& <CreateTask description={description} duration={duration} jobDetail={jobDetail} projectBudget={projectBudget} />} */}
        {jobDetail.payment_categorization?.toLowerCase() ===
          "milestone-based" && (
          <CreateMilestone
          currencySymbol={currencySymbol}
            description={description}
            duration={projectDuration}
            jobDetail={jobDetail}
            projectBudget={projectBudget}
            isBasic={isBasic}
            onDone={onDone}
          />
        )}
      </Box>
    </>
  );
};

export default FixedCostForm;
